import { Button, Row, Space } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import { invoicingStateDict } from '../orderdetail/components/OrderInfo/hooks'
import useSetupHook from './hooks'
import styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import Tippy from '@tippyjs/react'
import { formatTime } from '../../tools/util'

export default function OrderInvoice() {
  const {
    state,
    handlePaginationChange,
    handleSearchClick,
    handleJumpAddInvoice,
    onCombine,
    onSelectRow,
    onSelectAll,
    onChangeCheck,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption, selectedRows } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '下单时间',
      render: (text: any) => {
        return formatTime(text)
      },
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '下单金额',
      titleRender: (
        <div>
          <span>下单金额</span>
          <Tippy
            content={
              <div className={styles['tooltip-card']}>
                此为咸亨给您的下单金额，并非客户的下单金额，也并非实际开票金额
              </div>
            }
          >
            <QuestionCircleOutlined style={{marginLeft:'5px'}}/>
          </Tippy>
        </div>
      ),
    },
    {
      key: 'invoicingState',
      dataIndex: 'invoicingState',
      title: '开票状态',
      render: (text: any) => {
        return invoicingStateDict?.[text] ?? ''
      },
    },
    {
      key: 'invoicingState',
      title: '操作',
      render: (text: any, record: any) => {
        return (
          <span
            className="btn-link"
            onClick={() => {
              handleJumpAddInvoice([record.id])
            }}
          >
            提交开票
          </span>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'customer',
          'orderNo',
          'platform',
          'orderStartTime',
          'orderEndTime',
        ]}
        onSearch={handleSearchClick}
        keyName="INVOICEAPPLICATION"
        ScreenKey="INVOICEAPPLICATION"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Tippy
            content={
              <div className={styles['tooltip-card']}>
                <Row>1、订单状态为待验收或已完成</Row>
                <Row>2、订单尚未提交开票申请</Row>
              </div>
            }
          >
            <QuestionCircleOutlined style={{marginLeft:'5px'}}/>
          </Tippy>
          <span>可开票订单条件</span>
        </Space>
        <Button size="middle" type="primary" onClick={onCombine}>
          合并开票
        </Button>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: paginationOption.pageNo,
          pagesize: paginationOption.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
        defaultlist={selectedRows.map((item) => item.id)}
        onSelectRow={onSelectRow}
        onSelectAll={onSelectAll}
        onChangeCheck={onChangeCheck}
      ></TableAntd>
    </div>
  )
}
import { Button, Row, Space } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import { invoicingStateDict } from '../orderdetail/components/OrderInfo/hooks'
import useSetupHook from './hooks'
import styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import Tippy from '@tippyjs/react'
import { formatTime } from '../../tools/util'

export default function OrderInvoice() {
  const {
    state,
    handlePaginationChange,
    handleSearchClick,
    handleJumpAddInvoice,
    onCombine,
    onSelectRow,
    onSelectAll,
    onChangeCheck,
  } = useSetupHook()
  const { dataSource, isTableLoading, paginationOption, selectedRows } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
    },
    {
      key: 'customer',
      dataIndex: 'customer',
      title: '客户名称',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '下单时间',
      render: (text: any) => {
        return formatTime(text)
      },
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '下单金额',
      titleRender: (
        <div>
          <span>下单金额</span>
          <Tippy
            content={
              <div className={styles['tooltip-card']}>
                此为咸亨给您的下单金额，并非客户的下单金额，也并非实际开票金额
              </div>
            }
          >
            <QuestionCircleOutlined style={{marginLeft:'5px'}}/>
          </Tippy>
        </div>
      ),
    },
    {
      key: 'invoicingState',
      dataIndex: 'invoicingState',
      title: '开票状态',
      render: (text: any) => {
        return invoicingStateDict?.[text] ?? ''
      },
    },
    {
      key: 'invoicingState',
      title: '操作',
      render: (text: any, record: any) => {
        return (
          <span
            className="btn-link"
            onClick={() => {
              handleJumpAddInvoice([record.id])
            }}
          >
            提交开票
          </span>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'customer',
          'orderNo',
          'platform',
          'orderStartTime',
          'orderEndTime',
        ]}
        onSearch={handleSearchClick}
        keyName="INVOICEAPPLICATION"
        ScreenKey="INVOICEAPPLICATION"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Tippy
            content={
              <div className={styles['tooltip-card']}>
                <Row>1、订单状态为待验收或已完成</Row>
                <Row>2、订单尚未提交开票申请</Row>
              </div>
            }
          >
            <QuestionCircleOutlined style={{marginLeft:'5px'}}/>
          </Tippy>
          <span>可开票订单条件</span>
        </Space>
        <Button size="middle" type="primary" onClick={onCombine}>
          合并开票
        </Button>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: paginationOption.pageNo,
          pagesize: paginationOption.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
        defaultlist={selectedRows.map((item) => item.id)}
        onSelectRow={onSelectRow}
        onSelectAll={onSelectAll}
        onChangeCheck={onChangeCheck}
      ></TableAntd>
    </div>
  )
}
